import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "max-w-container px-container py-8 lg:py-16" }
const _hoisted_2 = { class: "max-w-5xl mx-auto md:grid grid-cols-3" }
const _hoisted_3 = { class: "relative w-48 h-48 mx-auto text-amff-teal" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  viewBox: "0 0 375 375",
  class: "absolute inset-0"
}, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "187.5",
    cy: "187.5",
    r: "187.5",
    fill: "transparent",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-location": "inside",
    "stroke-dasharray": "16 8"
  })
], -1)
const _hoisted_5 = { class: "\n            mt-2\n            text-2xl\n            font-bold\n            md:absolute\n            md:bottom-0\n            md:right-0\n            md:-mr-3\n          " }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previousEditions, (year) => {
        return (_openBlock(), _createBlock("a", {
          key: year,
          class: "\n          my-8\n          lg:my-10\n          lg:w-64\n          block\n          relative\n          text-center\n          lg:transform\n          lg:transition-transform\n          lg:hover:scale-105\n        ",
          href: `https://anteriores.atlantidafilmfest.es/${year}`,
          target: "_blank"
        }, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("img", {
              src: `${_ctx.baseURL}img/previous-editions/${year}/bitmap.png?2023`,
              srcset: 
              `${_ctx.baseURL}img/previous-editions/${year}/bitmap.png?2023 186w, ` +
              `${_ctx.baseURL}img/previous-editions/${year}/bitmap@2x.png?2023 372w, ` +
              `${_ctx.baseURL}img/previous-editions/${year}/bitmap@3x.png?2023 558w`
            ,
              alt: "",
              class: "absolute inset-0 p-2 rounded-full"
            }, null, 8, ["src", "srcset"])
          ]),
          _createVNode("div", _hoisted_5, _toDisplayString(year), 1)
        ], 8, ["href"]))
      }), 128))
    ])
  ]))
}